import { MarkAreaInPictureQuestionDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditNumber from '../Editors/EditNumber';
import GenPropQuestion from './GenPropQuestion';
import PrePostFixQuestion from './PrePostFixQuestion';
import EditAnswers from '../Editors/EditAnswers';

interface PostEditQuizMarkAreaInPictureQuestionProps {
    epc: EditPartContainerType;
    registerClosed?: boolean;
}

const PostEditQuizMarkAreaInPictureQuestion = (p: PostEditQuizMarkAreaInPictureQuestionProps) => {
    const { epc, registerClosed } = p;
    return (
        <>
            <GenPropQuestion epc={epc} registerClosed={registerClosed} />
            <EditPartContainer icon="cog" title="answers" {...epc} registerClosed={false}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "game", content: "area opacity" }, editor: <EditNumber<MarkAreaInPictureQuestionDownloadDto> getter={x => x.areaOpacity} /> },
                        { label: { icon: "tag", content: "answers" }, editor: <EditAnswers< MarkAreaInPictureQuestionDownloadDto> getter={x => x.possibleAnswers} noInput /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
            <PrePostFixQuestion epc={epc} registerClosed={registerClosed} />
        </>
    );
}
export default PostEditQuizMarkAreaInPictureQuestion;